import { QUESTION_INSIGHTS_API } from "admin/types/constants/questionInsights";
import type { ClassificationSummary } from "admin/types/interfaces/questionInsights";
import { useFetcher } from "~/hooks/useFetcher";

interface UseQuestionInsightsParams {
  // Restrict every figure to one originating app. Omit to aggregate all apps.
  appId?: string;
}

function buildUrl({ appId }: UseQuestionInsightsParams): string {
  const params = new URLSearchParams();
  if (appId) {
    params.set("app_id", appId);
  }
  const queryString = params.toString();
  return `${QUESTION_INSIGHTS_API}/summary${queryString ? `?${queryString}` : ""}`;
}

const useQuestionInsights = ({ appId }: UseQuestionInsightsParams = {}) => {
  const url = buildUrl({ appId });

  const { data, error, isLoading } = useFetcher<ClassificationSummary>(url, {
    shouldCamelize: true,
    keepPreviousData: true,
  });

  return {
    summary: data,
    error,
    isLoading,
    key: url, // resolved SWR key so callers can revalidate
  };
};

export default useQuestionInsights;
